<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
<!--      <div class="btn-box"></div>-->

      <div>
        <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">付费时间</span>
        <el-date-picker v-model="timevalue" size="small" type="datetimerange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
      <div style="display: flex; justify-content: flex-end">
        <input-search placeholder="车牌号" @search="searchKey" />
        <button-export
          style="margin-left: 5px"
          :href="exportUrl"
          download="download.xls"
          :beforeDownload="beforeDownload"
          v-if="permissionCodes.indexOf('004027001') !== -1"
          value="导出"
        />
      </div>
    </div>
    <div class="search-line">
        <input-select
          :selectTitle="'付费状态'"
          style="margin-left: 10px"
          :selectData="payStatusList"
          @search="search"
          :selectKey="'status'"
        />
        <input-select
          :selectTitle="'付费类型'"
          style="margin-left: 10px"
          :selectData="payTypeList"
          @search="search"
          :selectKey="'payType'"
        />
        <input-select
          :selectTitle="'付费方式'"
          style="margin-left: 10px"
          :selectData="payChannelList"
          @search="search"
          :selectKey="'payChannel'"
        />
    </div>
    <table-main
      :selection="false"
      :tableHead="tableHead"
      :tableData="tableData"
      @changeSelection="changeSelection"
      :total="total"
      :pageNum="pageNum"
      :pageSize="pageSize"
      @changePagination="changePagination"
      :hasOperation="false"
    />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/ParkingService";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "parking-pay-record",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧停车",
          name: "amount-allocation"
        },
        {
          value: "临停收费"
        }
      ],
      // addCustom: 'amount-add',
      exportUrl: "",
      payStatusList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "0",
          label: "未缴费"
        },
        {
          key: "1",
          label: "已缴费"
        }
      ],
      payTypeList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "1",
          label: "出场缴费"
        },
        {
          key: "2",
          label: "提前缴费"
        }
      ],
      payChannelList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "1",
          label: "微信"
        },
        {
          key: "2",
          label: "支付宝"
        },
        {
          key: "3",
          label: "银行转账"
        },
        {
          key: "4",
          label: "现金"
        },
        {
          key: "6",
          label: "无感支付"
        },
        {
          key: "5",
          label: "其他"
        }
      ],
      tableHead: [
        {
          prop: "carNumber",
          label: "车牌号"
        },
        {
          prop: "parkingDuration",
          label: "停车时长"
        },
        {
          prop: "money",
          label: "应收金额(元)"
        },
        {
          prop: "shouldPayMoney",
          label: "实收金额(元)"
        },
        {
          prop: "statusText",
          label: "付费状态"
        },
        {
          prop: "payTypeText",
          label: "付费类型"
        },
        {
          prop: "payChannelText",
          label: "付费方式"
        },
        {
          prop: "consumeTime",
          label: "付费时间"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: "",
        status: "",
        payType: "",
        payChannel: ""
      },
      timevalue: []
    };
  },
  created() {
    this.getCreateTime();
    this.permissionCodes = bus.global.permissionCodes;
  },
  activated() {
    this.getCreateTime();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportTempraryRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&status=${this.requestData.status}&payType=${
        this.requestData.payType
      }&payChannel=${this.requestData.payChannel}&startTime=${
        this.requestData.startTime
      }&endTime=${this.requestData.endTime}`;
    },
    getCreateTime() {
      this.timevalue = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timevalue[0] = year + "-" + month + "-" + date + " " + "00:00:00";
      this.timevalue[1] = year + "-" + month + "-" + date + " " + "23:59:59";
      this.getPage();
    },
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0];
        this.requestData.endTime = this.timevalue[1];
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getTempraryRecordPage, reqData)
        .then(res => {
          if (res.data.retCode == 1) {
            let data = res.data.data.list;
            data.map(v => {
              if (v.payTime) {
                v.payTime = v.payTime.slice(0, 19);
              }
              if (v.status === "0") {
                v.statusText = "未缴费";
              } else if (v.status === "1") {
                v.statusText = "已缴费";
              }
              if (v.payType === "1") {
                v.payTypeText = "出场缴费";
              } else if (v.payType === "2") {
                v.payTypeText = "提前缴费";
              }
              if (v.payChannel === "1") {
                v.payChannelText = "微信";
              } else if (v.payChannel === "2") {
                v.payChannelText = "支付宝";
              } else if (v.payChannel === "3") {
                v.payChannelText = "银行转账";
              } else if (v.payChannel === "4") {
                v.payChannelText = "现金";
              } else if (v.payChannel === "5") {
                v.payChannelText = "其他";
              } else if (v.payChannel === "6") {
                v.payChannelText = "无感支付";
              }
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取金额信息失败"));
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    }
  },
  watch: {
    timevalue(val) {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingPayRecord/TemporaryStop.vue